<div *ngIf="screenWidth >= FOOTER_EXTENDED_MIN_WIDTH">
	<div class="flex justify-content-around flex-wrap max-w-screen">
		<div class="grid col-12 align-items-center justify-content-between text-sm p-0 surface-900">
			<div class="col-6 flex align-items-center justify-content-start py-2">
				<p-button styleClass="p-button-footer-privacy text-sm" (onClick)="changeLanguage()">
					<ng-template pTemplate="content">
						<div class="flex flex-row gap-3 align-items-center">
							<img alt="{{ getCurrentLanguageName() }}" [src]="getCurrentLanguageFlag()" class="w-2rem">
							{{ getCurrentLanguageName() }}
						</div>
					</ng-template>
				</p-button>
				<div class="noSelectLabel-commonFooter text-300">|</div>
				<p-button styleClass="p-button-footer-privacy text-sm" label="{{ 'FOOTER_TERMS' | translate }}"
					(onClick)="openNewTab('/privacy/terms')"></p-button>
				<div class="noSelectLabel-commonFooter text-300">|</div>
				<p-button styleClass="p-button-footer-privacy text-sm" label="{{ 'FOOTER_PRIVACY' | translate }}"
					(onClick)="openNewTab('/privacy/policy')"></p-button>
				<div class="noSelectLabel-commonFooter text-300">|</div>
				<p-button styleClass="p-button-footer-privacy text-sm" label="{{ 'FOOTER_COOKIES' | translate }}"
					(onClick)="openNewTab('/privacy/cookies')"></p-button>
				<div class="noSelectLabel-commonFooter text-300">|</div>
				<p-button styleClass="p-button-footer-privacy text-sm" label="{{ 'FOOTER_CONTACT_US' | translate }}"
					(onClick)="openNewTabContactUs()"></p-button>
				<!-- <div class="noSelectLabel-commonFooter text-300">|</div>
				<p-button styleClass="p-button-footer-privacy text-sm" label="{{ 'FOOTER_PUBLIC_DOWNLOADS' | translate }}"
					(onClick)="openPublicDownloads()"></p-button> -->
			</div>
			<div class="col-6 flex align-items-center justify-content-end py-2">
				<label class="text-300 text-sm">{{copyrightInfo()}}</label>
			</div>
		</div>
	</div>
</div>
<div *ngIf="screenWidth < FOOTER_EXTENDED_MIN_WIDTH">
	<div class="flex justify-content-around flex-wrap max-w-screen">
		<div class="grid col-12 align-items-center justify-content-center text-sm surface-900 border-top-1 border-600">
			<div class="col-12 flex justify-content-center pt-1">
				<img src="assets/images/logos/CAME-A_alpha.png" alt="Logo" style="height:1.5rem;" />
			</div>
			<div class="col-12 flex justify-content-center py-0">
				<p-button styleClass="p-button-footer-privacy text-sm" (onClick)="changeLanguage()">
					<ng-template pTemplate="content">
						<div class="flex flex-row gap-3 align-items-center">
							<img alt="{{ getCurrentLanguageName() }}" [src]="getCurrentLanguageFlag()" class="w-2rem">
							{{ getCurrentLanguageName() }}
						</div>
					</ng-template>
				</p-button>
			</div>
			<div *ngIf="!onExtendedMobile()" class="col-12 flex justify-content-center py-1">
				<p-button styleClass="p-button-footer-privacy text-sm underline" label="{{ 'FOOTER_TERMS' | translate }}"
					(onClick)="openNewTab('/privacy/terms')"></p-button>
				<p-button styleClass="p-button-footer-privacy text-sm underline" label="{{ 'FOOTER_PRIVACY' | translate }}"
					(onClick)="openNewTab('/privacy/policy')"></p-button>
				<p-button styleClass="p-button-footer-privacy text-sm underline" label="{{ 'FOOTER_COOKIES' | translate }}"
					(onClick)="openNewTab('/privacy/cookies')"></p-button>
				<p-button styleClass="p-button-footer-privacy text-sm underline"
					label="{{ 'FOOTER_CONTACT_US' | translate }}" (onClick)="openNewTabContactUs()"></p-button>
				<!-- <p-button styleClass="p-button-footer-privacy text-sm underline"
					label="{{ 'FOOTER_FOOTER_PUBLIC_DOWNLOADSDOWNLOADS' | translate }}" (onClick)="openPublicDownloads()"></p-button> -->
			</div>
			<div *ngIf="onExtendedMobile()" class="grid mt-0">
				<div class="col-12 flex justify-content-center py-0">
					<p-button styleClass="p-button-footer-privacy text-sm underline" label="{{ 'FOOTER_TERMS' | translate }}"
						(onClick)="openNewTab('/privacy/terms')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button styleClass="p-button-footer-privacy text-sm underline"
						label="{{ 'FOOTER_PRIVACY' | translate }}" (onClick)="openNewTab('/privacy/policy')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button styleClass="p-button-footer-privacy text-sm underline"
						label="{{ 'FOOTER_COOKIES' | translate }}" (onClick)="openNewTab('/privacy/cookies')"></p-button>
				</div>
				<div class="col-12 flex justify-content-center py-0">
					<p-button styleClass="p-button-footer-privacy text-sm underline"
						label="{{ 'FOOTER_CONTACT_US' | translate }}" (onClick)="openNewTabContactUs()"></p-button>
				</div>
				<!-- <div class="col-12 flex justify-content-center py-0">
					<p-button styleClass="p-button-footer-privacy text-sm underline"
						label="{{ 'FOOTER_PUBLIC_DOWNLOADS' | translate }}" (onClick)="openPublicDownloads()"></p-button>
				</div> -->
			</div>
			<div class="col-12 flex justify-content-center text-center py-2">
				<label class="text-300 text-sm">{{ copyrightInfo() }}</label>
			</div>
		</div>
	</div>
</div>